import { PersonalDetailsForm, CommunicationDetailsForm } from "src/types/FormTypes";

export function mapBackendToPersonalDetails(personalDetails: any): PersonalDetailsForm {
  return {
    fullName: personalDetails.firstName || "",
    fathersName: personalDetails.fatherName || "",
    mothersName: personalDetails.motherName || "",
    gender: personalDetails.gender || "",
    maritalStatus: personalDetails.maritalStatus || "",
    dateOfBirth: personalDetails.dob || "",
    aadhaarCardNumber: personalDetails.aadhaarCardNumber || "",
    joiningInterest: personalDetails.joiningInterest
      ? [{ value: personalDetails.joiningInterest, label: personalDetails.joiningInterest }]
      : []
  };
}

export function mapBackendToCommunicationDetails(applicationInfo: any): CommunicationDetailsForm {
  const comm = applicationInfo.communicationDetails || {};
  const addr = comm.currentAddress || {};
  return {
    emailId: applicationInfo.emailId || "",
    mobileNumber: comm.mobileNumber || "",
    alternateEmailId: comm.altEmailId || "",
    alternateMobileNumber: comm.altMobileNumber || comm.altMobileNumber || "",
    streetAddress: addr.addressLine1 || "",
    city: addr.villageCity || "",
    district: addr.district || "",
    postOffice: addr.postOffice || "",
    state: addr.state || "",
    pinCode: addr.pincode || "",
    isPermanentAddressEnabled: true
  };
}
